$(document).ready(() => {
    if($('.store-location').length) {
        const y ='WDIhd6g';
        const z = 'SyBi18';
        const f = 'ke';
        const k ='941fLaRI';
        const o ='qVQJj6HE';
        const e ='AIza';
        const p = 'y=';
        const l = '3BBKdp';
        $(document).on('click', '.store-location__btn', function() {
            navigator.geolocation.getCurrentPosition(success, error);
    
            function success(position) {		
                let GEOCODING = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${position.coords.latitude}%2C${position.coords.longitude}&language=en&${f}${p}${e}${z}${o}${l}${y}${k}`;
    
                jQuery.getJSON(GEOCODING).done(function(location) {
                    let results = location.results;
                  console.log(results)
                    let address = results[0].formatted_address
                    $('.stockist-search-form .stockist-search-field').val(address);
                    $('.stockist-search-form button').trigger('click');
                })
    
            }
    
            function error(err) {
                console.log(err)
            }
        });
    }
});